import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manhwa';

export default function CategoryGrid() {
  const displayCategories = categories.slice(1);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            按照您喜欢的题材，发现更多精彩韩漫
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-3 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors flex-shrink-0">
                <i className={`${cat.icon} text-lg`}></i>
              </span>
              <div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}